// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainHeaderLogo[data-v-6c346497]{width:1.7rem;margin:0 .4rem;-webkit-user-drag:none}", ""]);
// Exports
module.exports = exports;
